import { ITranslitingTooltipRef } from "@components/global/new/TranslitingTooltip/TranslitingTooltip.props";
import { useRef } from "react";

const letters = [
  {
    eng: "A",
    rule: /\u0410/g,
  },
  {
    eng: "a",
    rule: /\u0430/g,
  },
  {
    eng: "B",
    rule: /\u0412/g,
  },
  {
    eng: "b",
    rule: /\u0432/g,
  },
  {
    eng: "E",
    rule: /\u0415/g,
  },
  {
    eng: "e",
    rule: /\u0435/g,
  },
  {
    eng: "K",
    rule: /\u041A/g,
  },
  {
    eng: "k",
    rule: /\u043A/g,
  },
  {
    eng: "M",
    rule: /\u041C/g,
  },
  {
    eng: "m",
    rule: /\u043C/g,
  },
  {
    eng: "H",
    rule: /\u041D/g,
  },
  {
    eng: "h",
    rule: /\u043D/g,
  },
  {
    eng: "O",
    rule: /\u041E/g,
  },
  {
    eng: "o",
    rule: /\u043E/g,
  },
  {
    eng: "P",
    rule: /\u0420/g,
  },
  {
    eng: "p",
    rule: /\u0440/g,
  },
  {
    eng: "C",
    rule: /\u0421/g,
  },
  {
    eng: "c",
    rule: /\u0441/g,
  },
  {
    eng: "T",
    rule: /\u0422/g,
  },
  {
    eng: "t",
    rule: /\u0442/g,
  },
  {
    eng: "Y",
    rule: /\u0423/g,
  },
  {
    eng: "y",
    rule: /\u0443/g,
  },
  {
    eng: "X",
    rule: /\u0425/g,
  },
  {
    eng: "x",
    rule: /\u0445/g,
  },
];

export const translitingText = (text: string) => {
  return letters.reduce((acc, item) => {
    return acc.replace(item.rule, item.eng);
  }, text);
};

export const useTransliting = () => {
  const ref = useRef<ITranslitingTooltipRef | null>(null);

  const getRef = (r: ITranslitingTooltipRef) => (ref.current = r);
  return {
    ref,

    getRef,
    onTranslit: translitingText,
  };
};
